import './main.vendors';

import bbModule from '../core/entry.module';
import bbMemberModule from '../member/entry.module';

import './_templates/basket_item_summary.html';
import './_templates/book_waitlist.html';
import './_templates/steps-main/main_appointment.html';
import './_templates/steps-main/main_appointments_member.html';
import './_templates/steps-main/main_confirmation.html';
import './_templates/steps-main/main_event_member.html';
import './_templates/steps-main/main_event.html';
import './_templates/steps-main/main_gift_certificate.html';
import './_templates/steps-main/main_view_booking.html';
import './_templates/steps-main/main.html';
import './_templates/steps/basket_summary.html';
import './_templates/steps/basket_wallet.html';
import './_templates/steps/basket.html';
import './_templates/steps/calendar.html';
import './_templates/steps/category_list.html';
import './_templates/steps/check_items.html';
import './_templates/steps/check_move.html';
import './_templates/steps/checkout_event.html';
import './_templates/steps/checkout.html';
import './_templates/steps/client.html';
import './_templates/steps/company_cards.html';
import './_templates/steps/company_list.html';
import './_templates/steps/confirmation.html';
import './_templates/steps/day.html';
import './_templates/steps/deal_list.html';
import './_templates/steps/duration_list.html';
import './_templates/steps/event_group_list.html';
import './_templates/steps/event_list.html';
import './_templates/steps/event.html';
import './_templates/steps/map.html';
import './_templates/steps/membership_levels.html';
import './_templates/steps/month_calendar.html';
import './_templates/steps/person_list.html';
import './_templates/steps/purchase.html';
import './_templates/steps/reschedule_reasons.html';
import './_templates/steps/resource_list.html';
import './_templates/steps/service_list.html';
import './_templates/steps/survey.html';
import './_templates/steps/time.html';

import translationsConfig from './_translations/en';

export default angular
    .module('BBPublicBooking', [
        bbModule,
        bbMemberModule
    ])
    .config(translationsConfig)
    .name;


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/public-booking/main.module.js